// @flow

import styled from 'styled-components';

export const SideDisplayValues = styled.div`
  padding: 16px;
  color: ${props => props.theme.colors.primary(10)};
  font-size: 0.9rem;
`;

export const SideDisplayValueItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 0.9rem;
`;

export const SideDisplayValueItemTitle = styled.div``;
export const SideDisplayValueItemValue = styled.div``;
